import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useMemo } from 'react';
import axios from 'axios';
import { getAgentElement } from '../getAgentElement';
import { updateExtraSituationalAwarenessContext } from '../situationalAwareness/useExtraSituationalAwarenessContext';
import config from 'utils/config';
import { sendMessageToThread } from '../threads/sendMessageToThread';
var description = "Runs an analysis of an already uploaded transcript(denoted by a fileId) after a user has selected which speaker they are in the transcript.\nMUST ONLY be used after a transcript has been uploaded but a user could NOT be matched.";
export function useMindsetAnalyzeUploadedTranscriptTool(containerId) {
  var tool = useMemo(function () {
    return {
      name: 'analyze_existing_transcript_file',
      description: description,
      parameters: {
        type: 'object',
        properties: {
          fileId: {
            type: 'string'
          },
          selectedSpeaker: {
            type: 'string'
          },
          s3FilePath: {
            type: 'string'
          }
        },
        required: ['fileId', 'selectedSpeaker']
      },
      handler: function () {
        var _handler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
          var fileId, selectedSpeaker, s3FilePath, _yield$axios$get, summaryAnalysis, _error$response, _t;
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                fileId = _ref.fileId, selectedSpeaker = _ref.selectedSpeaker, s3FilePath = _ref.s3FilePath;
                _context.prev = 1;
                _context.next = 2;
                return axios.get('/api/mindset/transcript/process', {
                  params: {
                    fileId: fileId,
                    selectedSpeaker: selectedSpeaker,
                    s3FilePath: s3FilePath
                  }
                });
              case 2:
                _yield$axios$get = _context.sent;
                summaryAnalysis = _yield$axios$get.data.summaryAnalysis;
                updateExtraSituationalAwarenessContext({
                  uploadedTranscriptFileName: String(fileId),
                  transcriptInitialAnalysis: JSON.stringify(summaryAnalysis)
                });
                sendMessageToThread(getAgentElement(containerId), config.helixMindsetSkillSummaryPrompt);
                return _context.abrupt("return", {
                  success: true
                });
              case 3:
                _context.prev = 3;
                _t = _context["catch"](1);
                _t.formattedErrorMessage = ((_error$response = _t.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.error) || _t.message;
                throw _t;
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[1, 3]]);
        }));
        function handler(_x) {
          return _handler.apply(this, arguments);
        }
        return handler;
      }()
    };
  }, [containerId]);
  return {
    tool: tool
  };
}